"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */function () {
  function FunctionToString() {
    /**
     * @inheritDoc
     */
    this.name = 'FunctionToString';
  }
  /**
   * @inheritDoc
   */
  FunctionToString.prototype.install = function () {
    originalFunctionToString = Function.prototype.toString;
    Function.prototype.toString = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var context = this.__sentry__ ? this.__sentry_original__ : this;
      // tslint:disable-next-line:no-unsafe-any
      return originalFunctionToString.apply(context, args);
    };
  };
  return FunctionToString;
}();
exports.FunctionToString = FunctionToString;